import cn from 'classnames';
import React from 'react';

import styles from './MaxWidthContainer.module.scss';

type Props = {
  children: React.ReactNode;
  className?: string;
};

export const MaxWidthContainer: React.FC<Props> = ({ children, className }) => {
  return <div className={cn(styles.container, className)}>{children}</div>;
};
